import { useContext } from 'react';
import { XStateContext } from 'components/app/AppContext';

export const useStateMachineContext = () => {
  const { actor, machine } = useContext(XStateContext);

  return {
    machine,
    actor,
    eventTypes: machine?.events.reduce((acc, event) => {
      return {
        ...acc,
        [event]: event
      };
    }, {})
  };
};
